<template>
  <div class="dialog-wrap">
    <el-dialog :title="title"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               @open="open()"
               :append-to-body="true"
               width="700px">
      <el-form class="form"
               :model="dataForm"
               :rules="rules"
               ref="dataForm"
               label-width="100px">

        <el-form-item label="院校名称"
                      prop="college"
                      v-if="title == '编辑复试参考书'">
          <el-select v-model="dataForm.college"
                     filterable
                     clearable
                     placeholder="请选择"
                     @change="collegeChange"
                     style="width: 100%">
            <el-option v-for="(item, index) in $store.state.collegeList"
                       :key="index"
                       :label="item.name"
                       :value="{ value: item.code, label: item.name }">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="专业名称"
                      prop="major">
          <el-select v-model="dataForm.major"
                     filterable
                     clearable
                     placeholder="请选择"
                     @change="majorChange"
                     style="width: 100%">
            <el-option v-for="(item, index) in majorList"
                       :key="index"
                       :label="item.name"
                       :value="{ value: item.code, label: item.name }">
              <span>{{ `（${item.code}）${item.name}` }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="学院名称"
                      prop="academy">
          <el-select v-model="dataForm.academy"
                     filterable
                     clearable
                     placeholder="请选择"
                     @change="academyChange"
                     style="width: 100%">
            <el-option v-for="(item, index) in academylist"
                       :key="index"
                       :label="item.academy_name"
                       :value="{
                      value: item.academy_code,
                      label: item.academy_name,
                      directions: item.directions,
                    }">
              <span>{{
                `（${item.academy_code}）${item.academy_name}`
              }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="方向名称"
                      prop="direction">
          <el-select v-model="dataForm.direction"
                     filterable
                     clearable
                     placeholder="请选择"
                     style="width: 100%">
            <el-option v-for="(item, index) in directionlist"
                       :key="index"
                       :label="item.direction"
                       :value="{
                      value: item.direction_code,
                      label: item.direction,
                    }">
              <span>{{
                `（${item.direction_code}）${item.direction}`
              }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="科目"
                      prop="subject">
          <el-select v-model="dataForm.subject"
                     filterable
                     clearable
                     placeholder="请选择"
                     style="width: 100%">
            <el-option v-for="(item, index) in subjectsList"
                       :key="index"
                       :label="`（${item.subject_code}）${item.subject_name}`"
                       :value="{ value: item.subject_code, label: item.subject_name }">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="学习方式"
                      prop="enrol_type">
          <el-select v-model="dataForm.enrol_type"
                     clearable
                     placeholder="请选择"
                     style="width: 100%">
            <el-option label="全日制"
                       :value="1">
            </el-option>
            <el-option label="非全日制"
                       :value="2">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="书名"
                      prop="book_name">
          <el-input v-model="dataForm.book_name"
                    placeholder="请输入书名"></el-input>
        </el-form-item>
        <el-form-item label="作者"
                      prop="book_author">
          <el-input v-model="dataForm.book_author"
                    placeholder="请输入作者"></el-input>
        </el-form-item>
        <el-form-item label="版次"
                      prop="book_edition">
          <el-input v-model="dataForm.book_edition"
                    placeholder="请输入版次"></el-input>
        </el-form-item>
        <el-form-item label="出版社"
                      prop="book_publisher">
          <el-input v-model="dataForm.book_publisher"
                    placeholder="请输入出版社"></el-input>
        </el-form-item>
        <el-form-item label="出版年份"
                      prop="book_year">
          <el-input v-model="dataForm.book_year"
                    placeholder="请输入出版年份"></el-input>
        </el-form-item>
      </el-form>
      <div class="footers">
        <div>
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary"
                     @click="handleSubmit">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  secondBookCreated,
  secondBookDetail,
  secondBookPut,
} from '@/api/admission'
import { collegeMajorList, majorinfo, majorSubjectList } from '@/api/common'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    detail: {
      type: Object,
      default: () => {
        return {}
      },
    },
    title: {
      type: String,
      default: () => {
        return '新建复试参考书'
      },
    },
    rowId: {
      type: Number,
      default: null,
    },
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      rules: {
        college: [
          { required: true, message: '请选择院校', trigger: 'change' },
        ],
        major: [
          { required: true, message: '请选择专业', trigger: 'change' },
        ],
        academy: [
          { required: true, message: '请选择学院', trigger: 'change' },
        ],
        subject: [
          { required: true, message: '请选择科目', trigger: 'change' },
        ],
        enrol_type: [
          { required: true, message: '请选择学习方式', trigger: 'change' },
        ],
        book_name: [
          { required: true, message: '请输入书名', trigger: 'blur' },
        ],
      },
      dataForm: {
        college: {},
        major: {},
        academy: {},
        direction: {},
        subject: {},
        enrol_type: '',
        book_name: '',
        book_author: '',
        book_edition: '',
        book_publisher: '',
        book_year: '',
      },
      rowDetail: {},
      majorList: [],
      academylist: [],
      directionlist: [],
      subjectsList: [],
    }
  },

  methods: {
    // 编辑时院校变化 → 重置专业/学院/方向/科目并加载专业列表
    collegeChange(e) {
      this.$set(this.dataForm, 'major', {})
      this.$set(this.dataForm, 'academy', {})
      this.$set(this.dataForm, 'direction', {})
      this.$set(this.dataForm, 'subject', {})
      this.academylist = []
      this.directionlist = []
      this.subjectsList = []
      this.fetchMajor(e.value)
    },
    // 专业下拉数据（新增时按父级院校加载）
    fetchMajor(college_code) {
      collegeMajorList({ college_code, isPaging: 0 }).then((res) => {
        this.majorList = res.list
      })
    },
    // 专业变化 → 加载学院/方向 + 科目（分数线同款三级联动）
    majorChange(e) {
      this.$set(this.dataForm, 'academy', {})
      this.$set(this.dataForm, 'direction', {})
      this.$set(this.dataForm, 'subject', {})
      this.directionlist = []
      this.subjectsList = []
      this.fetchMajorInfo(this.dataForm.college.value, e.value)
      this.fetchSubjects(this.dataForm.college.value, e.value)
    },
    fetchMajorInfo(college_code, major_code) {
      return new Promise((resolve) => {
        majorinfo({ college_code, major_code, isPaging: 0 }).then((res) => {
          this.academylist = res.academys
          resolve(res)
        })
      })
    },
    // 学院变化 → 设置方向列表
    academyChange(e) {
      this.$set(this.dataForm, 'direction', {})
      this.directionlist = e.directions || []
    },
    // 科目下拉数据（按 院校+专业 加载）
    fetchSubjects(college_code, major_code) {
      majorSubjectList({ college_code, major_code, isPaging: 0 }).then(
        (res) => {
          this.subjectsList = res.list
        }
      )
    },
    handleClose() {
      this.$emit('close')
      this.dataForm = {
        college: {},
        major: {},
        academy: {},
        direction: {},
        subject: {},
        enrol_type: '',
        book_name: '',
        book_author: '',
        book_edition: '',
        book_publisher: '',
        book_year: '',
      }
      this.majorList = []
      this.academylist = []
      this.directionlist = []
      this.subjectsList = []
      this.$refs['dataForm'].resetFields()
    },
    open() {
      if (this.title == '新建复试参考书') {
        // 新增：院校由父级带入作为默认值（仅用于联动传参，界面不显示）
        this.$set(this.dataForm, 'college', {
          value: this.detail.college_code,
          label: this.detail.college_name,
        })
        this.fetchMajor(this.detail.college_code)
      } else {
        // 编辑：回显 院校/专业/学院/方向/科目/参考书
        secondBookDetail({ id: this.rowId }).then((res) => {
          this.rowDetail = res
          // 参考书拆分字段
          this.$set(this.dataForm, 'book_name', res.book_name)
          this.$set(this.dataForm, 'book_author', res.book_author)
          this.$set(this.dataForm, 'book_edition', res.book_edition)
          this.$set(this.dataForm, 'book_publisher', res.book_publisher)
          this.$set(this.dataForm, 'book_year', res.book_year)
          // 院校/专业/学院/方向
          this.$set(this.dataForm, 'college', {
            value: res.college_code,
            label: res.college_name,
          })
          this.$set(this.dataForm, 'major', {
            value: res.major_code,
            label: res.major_name,
          })
          this.$set(this.dataForm, 'academy', {
            value: res.academy_code,
            label: res.academy_name,
          })
          this.$set(this.dataForm, 'direction', {
            value: res.direction_code,
            label: res.direction_name,
          })
          // 科目：优先 subject_code/name，兜底 subject_1
          if (res.subject_code) {
            this.$set(this.dataForm, 'subject', {
              value: res.subject_code,
              label: res.subject_name,
            })
          } else if (res.subject_1_code) {
            this.$set(this.dataForm, 'subject', {
              value: res.subject_1_code,
              label: res.subject_1_name,
            })
          }
          // 学习方式
          this.$set(this.dataForm, 'enrol_type', Number(res.enrol_type))
          // 按回显院校加载专业列表
          this.fetchMajor(res.college_code)
          // 按 院校+专业 加载学院/方向（=== 匹配当前行学院，兜底方向）
          this.fetchMajorInfo(res.college_code, res.major_code).then(
            (info) => {
              const academys = info.academys || []
              const target = academys.find(
                (v) => v.academy_code === res.academy_code
              )
              if (target && Array.isArray(target.directions)) {
                this.directionlist = target.directions
              } else if (res.direction_code) {
                this.directionlist = [
                  {
                    direction_code: res.direction_code,
                    direction: res.direction_name,
                  },
                ]
              } else {
                this.directionlist = []
              }
            }
          )
          // 按 院校+专业 加载科目
          this.fetchSubjects(res.college_code, res.major_code)
        })
      }
    },
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          if (this.title == '新建复试参考书') {
            let data = {
              year: this.detail.current_search_year,
              college_code: this.detail.college_code,
              college_name: this.detail.college_name,
              academy_code: this.dataForm.academy.value,
              academy_name: this.dataForm.academy.label,
              major_code: this.dataForm.major.value,
              major_name: this.dataForm.major.label,
              direction_code: this.dataForm.direction.value,
              direction_name: this.dataForm.direction.label,
              subject_code: this.dataForm.subject.value,
              subject_name: this.dataForm.subject.label,
              enrol_type: this.dataForm.enrol_type,
              book_name: this.dataForm.book_name,
              book_author: this.dataForm.book_author,
              book_edition: this.dataForm.book_edition,
              book_publisher: this.dataForm.book_publisher,
              book_year: this.dataForm.book_year,
            }
            secondBookCreated(data).then(() => {
              this.handleClose()
              this.$emit('submit')
              this.$message.success(`操作成功`)
            })
          } else {
            let data = {
              id: this.rowId,
              year: this.detail.current_search_year,
              college_code: this.dataForm.college.value,
              college_name: this.dataForm.college.label,
              academy_code: this.dataForm.academy.value,
              academy_name: this.dataForm.academy.label,
              major_code: this.dataForm.major.value,
              major_name: this.dataForm.major.label,
              direction_code: this.dataForm.direction.value,
              direction_name: this.dataForm.direction.label,
              subject_code: this.dataForm.subject.value,
              subject_name: this.dataForm.subject.label,
              enrol_type: this.dataForm.enrol_type,
              book_name: this.dataForm.book_name,
              book_author: this.dataForm.book_author,
              book_edition: this.dataForm.book_edition,
              book_publisher: this.dataForm.book_publisher,
              book_year: this.dataForm.book_year,
            }
            secondBookPut(data).then(() => {
              this.handleClose()
              this.$emit('submit')
              this.$message.success(`修改成功`)
            })
          }
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
::v-deep .el-dialog__header {
  background: #ebeef5;
}
.cover-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  width: 112px;
  height: 112px;
}

.cover-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  max-width: 100%;
  max-height: 200px;
  line-height: 100px;
  text-align: center;
}
.cover {
  display: block;
  max-width: 100%;
  max-height: 200px;
  object-fit: cover;
  margin: 0 auto;
}
.border {
  padding: 10px;
  width: 100%;
  border: 1px dashed #d9d9d9;
}
.desc {
  margin-top: 10px;
  font-weight: normal;
  font-size: 12px;
  color: #cccccc;
}
.footers {
  display: flex;
  justify-content: flex-end;
}
</style>
